import React from 'react';
import {
    NavLink,
    Link
} from 'react-router-dom'

class Single extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {}

    render() {
        let {item, type, noImg} = this.props;
        return (
            <div className="journal-item">
               <h6 className="topic">{type}</h6>
                <span className="date d-block">{item.formatted_date}</span>
                <Link to={`${process.env.PUBLIC_URL}/journal/${item.post_name}`} >
                    <div className="links">
                        <h3 className="journal-title">{item.post_title}</h3>
                        {!noImg &&
                            <figure><img src={item.image.url} alt={item.post_title} title={item.post_title} /></figure>
                        }
                    </div>
                </Link>
            </div>
        );
    }
}

export default Single;


// WEBPACK FOOTER //
// ./src/components/Journals/Single.js